const strings = {
  textModal: {
    addModalTitle: 'Adicionar Usuário',
  },
}

export default strings
